import Vue from 'vue'
import Compressor from 'compressorjs'
import VueCropper from 'vue-cropper'
// import * as fundebug from 'fundebug-javascript'
// import FundebugVue from 'fundebug-vue'
Vue.use(VueCropper)
Vue.prototype.$Compressor = Compressor

// fundebug.apikey = '04042aa974a3b11017e8d84b97cccc5a31a0bc03669a2cceda21fec9029fb898'
// new FundebugVue(fundebug).installVueErrorHandler(Vue)
